var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-9_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0CA092",
  d: "M90 45C90 20.147 69.853 0 45 0S0 20.147 0 45s20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4A72C",
  d: "m31.361 60.627-1.747-1.748-1.748-1.747s-3.454-.45-6.154 3.352-2.205 8.502-2.205 8.502 4.7.495 8.502-2.206c3.802-2.703 3.352-6.153 3.352-6.153"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D13346",
  d: "m36.015 59.918-7.437-7.437-2.97 2.393 8.014 8.014z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M70.492 18.004s-14.689-.878-28.061 11.025C29.058 40.93 25.68 52.688 25.68 52.688s3.07 2.264 5.467 4.66L70.496 18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26517F",
  d: "M12.067 50.843s5.622-12.368 20.198-10.56c14.576 1.804-6.109 11.032-6.109 11.032s-4.582-3.37-14.089-.468z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6D6D6",
  d: "M70.493 18.004s.877 14.689-11.025 28.061-23.66 16.751-23.66 16.751-2.264-3.071-4.66-5.467L70.496 18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E3A54",
  d: "M37.653 76.429s12.368-5.622 10.56-20.198C46.41 41.655 37.181 62.34 37.181 62.34s3.37 4.582.468 14.089z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26517F",
  d: "M43.856 44.64s-6.03 2.527-11.31 7.807-7.808 11.31-7.808 11.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E3A54",
  d: "M43.856 44.64s-2.528 6.03-7.808 11.31-11.31 7.807-11.31 7.807z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4A72C",
  d: "M51.927 41.449a4.879 4.879 0 1 0 0-9.757 4.879 4.879 0 0 0 0 9.757"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D13346",
  d: "m59.74 28.755 10.752-10.752s-8.074-.476-17.7 4.125a200 200 0 0 1 6.949 6.627"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A51C34",
  d: "m59.741 28.755 10.752-10.751s.476 8.074-4.125 17.7a200 200 0 0 0-6.627-6.949"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-9_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h90v90H0z"
})))));
export { SvgAvatar9 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-9.ed8386691522c47b70e3.svg";